module.exports = __webpack_public_path__ + "img/jzfj.4eb57390.png";